export default class Header {
	/**
	 * @param {HTMLElement} element
	 */
	constructor(element) {
		this.element = element;
		this.stickyClass = "is-sticky";
		this.disableStickyClass = "Header--disableSticky";
		this.enableSticky = !this.element.classList.contains(
			this.disableStickyClass,
		);

		if (this.enableSticky) {
			window.addEventListener("scroll", () => {
				const scrollPosition =
					window.scrollY || document.documentElement.scrollTop;

				if (scrollPosition > this.element.offsetHeight) {
					this.element.classList.add(this.stickyClass);
				} else {
					this.element.classList.remove(this.stickyClass);
				}
			});
		}
	}
}
